import { captureException } from '@sentry/react';
import { useFirebase } from 'containers/FirebaseContext';
import { get } from 'lodash';
import { useEffect, useMemo, useState } from 'react';
import { useCurrentClass } from 'store/classes/selectors';
import { useNotifications } from 'store/notification/selectors';
import { useUsersByClass } from 'store/userClasses/selectors';
import { useCurrentUser } from 'store/users/selectors';
import { useCollectionNotification } from 'utils/methods/firebaseNotification';

const useNotificationInstrucation = (instructionId) => {
  const usersByClass = useUsersByClass();
  const { createNotificationAssignment, listenToNotificationData, updateCollectionNotification, updateNotificationByInstructionId } =
    useCollectionNotification();
  const currentUser = useCurrentUser();
  const { firebaseUser } = useFirebase();
  const [notificationData, setNotificationData] = useState();
  const currentClass = useCurrentClass();

  useEffect(() => {
    if (!firebaseUser || (firebaseUser && Object.keys(firebaseUser).length === 0)) return;
    const unsubscribe = listenToNotificationData(
      get(currentClass, 'id', ''),
      currentUser,
      (data) => {
        setNotificationData(data);
      },
    );
    return () => {
      unsubscribe();
    };
  }, [currentClass, currentUser, firebaseUser]);

  const currentNotificationInstruction = useMemo(() => {
    try {
      const data = notificationData?.find((x) => x?.data?.id === instructionId);
      return data;
    } catch (error) {
      captureException(error);
    }
  }, [notificationData, instructionId]);

  const isCurrentStudentSeenInstruction = useMemo(() => {
    const isCurrentStudentSeenInstruction = currentNotificationInstruction?.userSeen?.includes(
      currentUser?.id,
    );
    return isCurrentStudentSeenInstruction && currentUser?.role === 'student';
  }, [currentUser, currentNotificationInstruction]);

  const updateUserSeen = () => {
    if (currentUser?.role === "student") {
      if (currentNotificationInstruction?.id && !currentNotificationInstruction?.userSeen?.includes(currentUser?.id)) {
        updateCollectionNotification(currentNotificationInstruction.id, currentUser?.id);
      } else if (instructionId && currentClass?.id && (!currentNotificationInstruction || !currentNotificationInstruction?.userSeen?.includes(currentUser?.id))) {
        updateNotificationByInstructionId(instructionId, currentClass.id, currentUser?.id);
      }
    }
  };

  const sendNotification = (data) => {
    try {
      createNotificationAssignment(data, usersByClass);
    } catch (error) {
      console.log(error, 'error');
    }
  };

  return {
    sendNotification,
    isCurrentStudentSeenInstruction,
    updateUserSeen,
    currentNotificationInstruction,
  };
};

export default useNotificationInstrucation;
